/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Tab_Audio_DescriptionsInputs */

const en_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio Descriptions`)
};

const fr_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descriptions audio`)
};

const de_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibungen`)
};

const it_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizioni audio`)
};

const ru_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудиоописания`)
};

const es_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripciones de audio`)
};

const zh_cn2_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频描述`)
};

const ja_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音声説明`)
};

const hi_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो विवरण`)
};

const pt_pt2_preset_manager_tab_audio_descriptions = /** @type {(inputs: Preset_Manager_Tab_Audio_DescriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrição de áudio`)
};

/**
* | output |
* | --- |
* | "Audio Descriptions" |
*
* @param {Preset_Manager_Tab_Audio_DescriptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_tab_audio_descriptions = /** @type {((inputs?: Preset_Manager_Tab_Audio_DescriptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Tab_Audio_DescriptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "de") return de_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "it") return it_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "ru") return ru_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "es") return es_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "ja") return ja_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "hi") return hi_preset_manager_tab_audio_descriptions(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_tab_audio_descriptions(inputs)
	return en_preset_manager_tab_audio_descriptions(inputs)
});